import React, { useEffect, useRef, useState } from 'react'

export default function CustomCursor() {
  const dotRef = useRef(null)
  const ringRef = useRef(null)
  const [isHovering, setIsHovering] = useState(false)

  // Don't render on touch devices
  const isTouch = typeof window !== 'undefined' &&
    ('ontouchstart' in window || navigator.maxTouchPoints > 0)

  useEffect(() => {
    if (isTouch) return

    let raf
    let mouse = { x: -100, y: -100 }
    let ring = { x: -100, y: -100 }

    const onMove = (e) => {
      mouse.x = e.clientX
      mouse.y = e.clientY
    }
    const onOver = (e) => {
      const t = e.target
      if (t.closest('a, button, input, textarea, [data-cursor-hover]')) setIsHovering(true)
    }
    const onOut = () => setIsHovering(false)

    document.addEventListener('mousemove', onMove, { passive: true })
    document.addEventListener('mouseover', onOver, { passive: true })
    document.addEventListener('mouseout', onOut, { passive: true })

    const lerp = (a, b, t) => a + (b - a) * t
    const loop = () => {
      ring.x = lerp(ring.x, mouse.x, 0.12)
      ring.y = lerp(ring.y, mouse.y, 0.12)
      if (dotRef.current) dotRef.current.style.transform = `translate(${mouse.x - 4}px, ${mouse.y - 4}px)`
      if (ringRef.current) ringRef.current.style.transform = `translate(${ring.x - 20}px, ${ring.y - 20}px)`
      raf = requestAnimationFrame(loop)
    }
    raf = requestAnimationFrame(loop)

    return () => {
      cancelAnimationFrame(raf)
      document.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseover', onOver)
      document.removeEventListener('mouseout', onOut)
    }
  }, [isTouch])

  if (isTouch) return null

  return (
    <>
      <div ref={dotRef} className="fixed top-0 left-0 pointer-events-none"
        style={{ width: 8, height: 8, borderRadius: '50%', background: '#F5A623', willChange: 'transform', zIndex: 2147483647 }} />
      <div ref={ringRef} className="fixed top-0 left-0 pointer-events-none"
        style={{
          width: 40, height: 40, borderRadius: '50%',
          border: `1.5px solid ${isHovering ? '#F5A623' : 'rgba(245,166,35,0.35)'}`,
          willChange: 'transform',
          transition: 'border-color 0.25s',
          zIndex: 2147483647,
        }} />
    </>
  )
}
